import { connect, Dispatch } from 'react-redux';
import { IRootState } from 'redux/root_reducer';

import {
    InventoryAction,
    searchInventory
} from 'redux/modules/inventory';

import TextSearch, { DispatchProps, StateProps } from 'components/global/form/TextSearch';

const mapStateToProps = (state: IRootState): StateProps => {
    return {
        isSearching: state.inventory.isSearching
    };
};

const mapDispatchToProps = (dispatch: Dispatch<InventoryAction>): DispatchProps => {
    return {
        searchInventory: (search: string) => dispatch<any>(searchInventory(search))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextSearch);



// WEBPACK FOOTER //
// ./src/containers/global/form/TextSearch.tsx